import React from 'react';

export function Pricing() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-orange-100 border border-orange-200 rounded-full px-6 py-2 mb-6">
            <span className="text-orange-700 font-semibold text-sm">🚀 EARLY BIRD PRICING</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Simple pricing
          </h2>
          <p className="text-xl text-gray-600">
            Join our waitlist and lock in early bird pricing for when we launch
          </p>
        </div>
        
        <div className="max-w-lg mx-auto">
          <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-8 border-2 border-orange-200 relative">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
              <div className="bg-orange-600 text-white px-4 py-2 rounded-full text-sm font-bold">
                50% OFF LAUNCH PRICE
              </div>
            </div>
            <div className="text-center pt-4">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">App Growth Audit</h3>
              <div className="mb-6">
                <span className="text-5xl font-bold text-orange-600">$19</span>
                <span className="text-gray-600 ml-2">early bird</span>
                <div className="text-sm text-gray-500 mt-1">
                  <span className="line-through">Regular price: $39</span>
                </div>
              </div>
              <p className="text-gray-600 mb-8">
                Complete analysis of what's blocking your app from getting users. Join the waitlist to secure this price when we launch.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Analytics tracking analysis (PostHog, GA)</span>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Customer support setup (Intercom, help docs)</span>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Email capture (newsletter, waitlist)</span>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Marketing pixels (Meta, TikTok)</span>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Conversion tracking analysis</span>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Prioritized action plan</span>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-orange-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Step-by-step implementation guide</span>
                </div>
              </div>
              
              <button className="w-full bg-orange-600 text-white font-bold py-3 px-6 rounded-full hover:bg-orange-700 transition-colors cursor-pointer">
                Join Waitlist - Lock in $19 Price
              </button>
              
              <p className="text-sm text-gray-500 mt-4">
                💡 Secure early bird pricing now - price goes to $39 at launch
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}